import React, { useEffect, useState } from 'react';
import pen from '../images/ill-pen@3x.png';
import BackIcon from '../components/BackIcon';
import PortalButton from '../components/Button';
function Agreement() {
  return (
    <>
      <div className="sm:flex sm:justify-between sm:items-center mb-8 ">
        <button className="btn">
          <BackIcon />
          <span className="ml-2 text-xl font-semibold text-portal-900">Confidentiality Agreement</span>
        </button>
      </div>

      <div className="">
        <div className="m-auto mt-2">
          <div className="">
            <div className="relative flex">
              <img className="absolute right-1  hidden lg:block w-[50%]" src={pen} alt="pen" />
              <div className="w-full lg:w-1/2 z-10">
                <div className="flex-1">
                  <div className="">
                    <div className="w-full mx-auto relative">
                      <div className="space-y-6">
                        <p className="text-portal-400">
                          Throughout the screening process, you may acquire protected and proprietary company information. The
                          includes, but is not limited to Laundry Care's business model, current and/or prospective client
                          information, current and/or future markets, target markets, pricing, partnerships, strategic business
                          plans, as well as specific company methods and/or manner of operation.
                        </p>
                        <h6 className="text-portal-500 font-semibold">
                          With this in mind, we ask you to read, agree and comply with the following terms.
                        </h6>
                        <p className="text-portal-400">
                          Throughout the screening process, you may acquire protected and proprietary company information. The
                          includes, but is not limited to Laundry Care's business model, current and/or prospective client
                          information, current and/or future markets, target markets, pricing, partnerships, strategic business
                          plans, as well as specific company methods and/or manner of operation.
                        </p>
                        <h6 className="text-portal-500 font-semibold">
                          I understand that I may be exposed to protected information throughout the screening process. I fully
                          understand any disclosure and/or exploitation of such information would result in damage to Laundry Care
                          and its subsidiaries.
                        </h6>
                        <div>
                          <label className="flex items-center">
                            <input type="checkbox" className="form-checkbox border-2 border-blue-400" />
                            <span className="text-sm ml-2">I Agree</span>
                          </label>
                        </div>
                        <h6 className="text-portal-500 font-semibold">
                          I have read and agree to act in good faith in adherence to the above non-disclosure agreement and
                          agreement to not complete.
                        </h6>
                        <div>
                          <label className="flex items-center">
                            <input type="checkbox" className="form-checkbox border-2 border-blue-400" />
                            <span className="text-sm ml-2">I Agree</span>
                          </label>
                        </div>
                        <h6 className="text-portal-500 font-semibold">
                          I specifically agree to hold any and all confidential or proprietary information learned during the
                          screening process in complete confidence.
                        </h6>
                        <div>
                          <label className="flex items-center">
                            <input type="checkbox" className="form-checkbox border-2 border-blue-400" />
                            <span className="text-sm ml-2">I Agree</span>
                          </label>
                        </div>
                        <h6 className="text-portal-500 font-semibold">
                          I specifically agree to refrain from exploiting any and all confidential or proprietary information
                          learned during the screening process to establish, manage and/or operate any other business which
                          directly competes with Laundry Care.
                        </h6>
                        <div>
                          <label className="flex items-center">
                            <input type="checkbox" className="form-checkbox border-2 border-blue-400" />
                            <span className="text-sm ml-2">I Agree</span>
                          </label>
                        </div>
                      </div>
                      <div className="flex my-4">
                        <div className="w-1/2 pr-3">
                          <PortalButton classes="w-full" variant="primary" text="Confirm" />
                        </div>
                        <div className="w-1/2 pl-3"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="hidden md:block top-0 bottom-0 right-0 lg:w-1/2 py-64" aria-hidden="true"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Agreement;
